// ----------------------------------------------------------------------

export function useMessage({ message, participants, currentUserId }) {
  const sender = (participants || []).find((participant) => participant.id === message?.senderId);

  const isMe =
    message.senderId === currentUserId ||
    (!sender && message.senderId !== 'assistant' && message.senderId !== 'support');

  const senderDetails = isMe
      ? { type: 'me' }
      : {
          avatarUrl: sender?.avatarUrl,
          firstName: sender?.name?.split(' ')?.[0] ?? (message.senderId === 'assistant' || message.senderId === 'support' ? 'AI' : 'User'),
          role: sender?.role
        };

  const me = senderDetails.type === 'me';

  const hasImage = message.contentType === 'image';

  return { hasImage, me, senderDetails };
}
